import * as React from 'react';
import { IconProps } from '../types';

const IcDelete = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path fill={props?.fill ?? '#232F3E'} d="M7.413 6H22.25v12H7.413L2.75 12l4.663-6Z" />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M17.561 8.485a.75.75 0 0 1 0 1.06l-6.094 6.095a.75.75 0 0 1-1.06-1.06L16.5 8.484a.75.75 0 0 1 1.06 0Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M10.406 8.485a.75.75 0 0 1 1.061 0l6.094 6.094a.75.75 0 1 1-1.06 1.06l-6.095-6.093a.75.75 0 0 1 0-1.061Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M17.561 8.485a.75.75 0 0 1 0 1.06l-6.094 6.095a.75.75 0 0 1-1.06-1.06L16.5 8.484a.75.75 0 0 1 1.06 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M10.406 8.485a.75.75 0 0 1 1.061 0l6.094 6.094a.75.75 0 1 1-1.06 1.06l-6.095-6.093a.75.75 0 0 1 0-1.061Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcDelete;